/* NPM */
import { useEffect } from "react";
import { AsHtml } from "@ww-digital/applanga-js";
/* UTILS */
import t from "../../utils/translate";
import { setCookieValue, SECONDS_IN_THIRTY_DAYS } from "../../utils/cookies";
import { STATE_UNSERVICEABLE } from "../../utils/eligibility";
import content from "./content";
import useAppContext from "../AppContext";
/* COMPONENTS */
import ContentGutter from "../ContentGutter";
import SiteWrapper from "../SiteWrapper";
import SequenceFooter from "../SequenceFooter";
/* STYLES */
import styles from "./styles.module.scss";
import NextButton from "../NextButton";

const StateNextStep = ({ page, proceed }) => {
  const { header, href, applangaKey, interpolations } = content[page] || {};
  const { authData } = useAppContext();
  const { loggedInAs } = authData || {};

  useEffect(() => {
    if (page === STATE_UNSERVICEABLE) {
      setCookieValue(
        "ww_assessment",
        { resultsScreenSequence: STATE_UNSERVICEABLE },
        SECONDS_IN_THIRTY_DAYS
      );
      setCookieValue("ww_results", { shown: true }, SECONDS_IN_THIRTY_DAYS);
    }
  }, [page]);

  return (
    <div className={styles.wrapper}>
      <ContentGutter>
        <SiteWrapper size="small">
          <div className={styles.header}>{header}</div>
          <AsHtml
            value={applangaKey}
            className={styles.text}
            tagType="div"
            interpolations={{
              ...interpolations,
              email: loggedInAs || ""
            }}
          />
          {href && (
            <a
              href={href}
              target="_blank"
              title="Learn More"
              rel="noopener noreferrer"
              className={styles.linkAsButton}
            >
              {t("LEARN_MORE")}
            </a>
          )}
          {!href && proceed && (
            <NextButton className={styles.nextButton} onNext={proceed} />
          )}
        </SiteWrapper>
      </ContentGutter>
      <SequenceFooter
        nextButtonProps={{}}
        hideButton={true}
        className={styles.footer}
      />
    </div>
  );
};

export default StateNextStep;
